<template>
  <lazy-div :load="doInit">
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">{{labels.general}}</div>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <message :messages="messages" v-if="!stdItemTextDialog"></message>
        <v-container fluid grid-list-lg>
          <form data-vv-scope="stdRiskTextForm">
            <v-layout row wrap>
              <v-flex xs6 v-if="newStdRiskText">
                <v-text-field data-vv-scope="stdRiskTextForm" :label="labels.stdRiskTxtRef" v-model="stdRiskTextForm.stdRiskTxtRef" :error-messages="errors.collect('stdRiskTextForm.stdRiskTxtRef')" v-validate="'required|param|max:3'" data-vv-name="stdRiskTxtRef" :data-vv-as="labels.stdRiskTxtRef"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.stdRiskTxtRef}}</v-subheader>
                <div class="subheading">{{stdRiskTextForm.stdRiskTxtRef}}</div>
              </v-flex>
              <v-flex xs6></v-flex>
              <v-flex xs6>
                <v-textarea auto-grow box rows="1" data-vv-scope="stdRiskTextForm" :label="labels.stdRiskTxtLn" v-model="stdRiskTextForm.stdRiskTxtLn" :error-messages="errors.collect('stdRiskTextForm.stdRiskTxtLn')" v-validate="'required|entry'" data-vv-name="stdRiskTxtLn" :data-vv-as="labels.stdRiskTxtLn"></v-textarea>
              </v-flex>
              <v-flex xs6>
                <v-textarea auto-grow box rows="1" data-vv-scope="stdRiskTextForm" :label="labels.stdRiskDetLn" v-model="stdRiskTextForm.stdRiskDetLn" :error-messages="errors.collect('stdRiskTextForm.stdRiskDetLn')" v-validate="'entry'" data-vv-name="stdRiskDetLn" :data-vv-as="labels.stdRiskDetLn"></v-textarea>
              </v-flex>
            </v-layout>
          </form>
        </v-container>
      </v-card-text>
      <v-flex xs12 row warp>
        <v-btn color="primary" type="submit" @click.prevent="doSaveStdRiskText">
          {{newStdRiskText ? 'Save Standard Risk Text' : 'Update Standard Risk Text'}}
          <v-icon right>{{newStdRiskText ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
    <v-divider></v-divider>
    <v-card v-if="!newStdRiskText">
      <v-card-title>
        <div>
          <div class="headline">{{labels.tableTitle}}</div>
        </div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="stdItemTxtRef" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.stdItemTxtRef }}</td>
          <td class="text-xs-left">{{ formatTextLength(props.item.stdItemTxtLn) }}</td>
          <td class="text-xs-left">{{ formatTextLength(props.item.stdItemOptTxtLn) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-dialog v-model="stdItemTextDialog" max-width="900px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">{{ labels.formTitle }}</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <form data-vv-scope="stdRiskItemTextForm">
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12 v-if="newStdRiskItemText">
                    <v-flex xs6>
                      <v-text-field data-vv-scope="stdRiskItemTextForm" v-model="stdRiskItemTextForm.stdItemTxtRef" :label="labels.stdItemTxtRef" :error-messages="errors.collect('stdRiskItemTextForm.stdItemTxtRef')" data-vv-name="stdItemTxtRef" :data-vv-as="labels.stdItemTxtRef" v-validate="'required|param|max:3'"></v-text-field>
                    </v-flex>
                    <v-flex xs6></v-flex>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{labels.stdItemTxtRef}}</v-subheader>
                      </v-flex>
                      <v-flex xs8 align-left>
                        <div class="subheading">{{stdRiskItemTextForm.stdItemTxtRef}}</div>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea auto-grow box rows="1" data-vv-scope="stdRiskItemTextForm" v-model="stdRiskItemTextForm.stdItemTxtLn" :label="labels.stdItemTxtLn" :error-messages="errors.collect('stdRiskItemTextForm.stdItemTxtLn')" v-validate="'entry'" data-vv-name="stdItemTxtLn" :data-vv-as="labels.stdItemTxtLn"></v-textarea>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea auto-grow box rows="1" data-vv-scope="stdRiskItemTextForm" v-model="stdRiskItemTextForm.stdItemOptTxtLn" :label="labels.stdItemOptTxtLn" :error-messages="errors.collect('stdRiskItemTextForm.stdItemOptTxtLn')" v-validate="'entry'" data-vv-name="stdItemOptTxtLn" :data-vv-as="labels.stdItemOptTxtLn"></v-textarea>
                  </v-flex>
                </v-layout>
              </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doCloseItemText">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="itemTextSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex xs12>
        <v-btn color="primary" dark class="mb-2" @click="doNewItemText">Add Item Text</v-btn>
      </v-flex>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Standard Risk Item Text? ({{deleteItemText}})
      </confirm>
    </v-card>
  </lazy-div>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import FieldMixin from '@/mixins/field'
import MessageMixin from '@/mixins/message'
export default {
  props: ['id'],
  data() {
    return {
      breadcrumb: [],
      headers: [
        { text: 'Standard Item Text Reference', value: 'stdItemTxtRef' },
        { text: 'Standard Item Text', value: 'stdItemTxtLn' },
        { text: 'Standard Item Optional Text', value: 'stdItemOptTxtLn' },
        TableConst.tableActionHeader
      ],
      labels: {
        general: 'Summary',
        stdRiskTxtRef: 'Standard Risk Text Reference',
        stdItemTxtRef: 'Standard Item Text Reference',
        stdRiskTxtLn: 'Standard Risk Text',
        stdItemOptTxtLn: 'Standard Item Optional Text',
        stdRiskDetLn: 'Standard Risk Details',
        stdItemTxtLn: 'Standard Item Text',
        tableTitle: 'Item Text',
        formTitle: 'Review Item Text'
      },
      stdRiskTextForm: {
        stdRiskTxtRef: null,
        stdRiskTxtLn: null,
        stdRiskDetLn: null
      },
      stdRiskItemTextForm: {
        stdRiskTxtRef: null,
        stdItemTxtRef: null,
        stdItemTxtLn: null,
        stdItemOptTxtLn: null
      },
      newStdRiskItemText: false,
      newStdRiskText: false,
      stdItemTextDialog: null,
      loading: false,
      promptRemove: false,
      selectedItemText: undefined,
      deleteItemText: '',
      submitting: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    stdRiskTextMenu() {
      return this.$store.state.parameters.stdRisk.text
    },
    stdRiskItemTextMenu() {
      return this.$store.state.parameters.stdRisk.itemText
    },
    noDataText() {
      if (this.newStdRiskText) {
        return 'Please add some Item Text value'
      } else {
        return ''
      }
    }
  },
  methods: {
    async stdRiskTextFormInit() {
      await this.$store.dispatch('stdRiskTextInit')
      const apiURI = this.stdRiskTextMenu.menu.stdRiskTxt
      if (apiURI) {
        try {
          const expand = {
            stdRiskTxtRef: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.stdRiskTextForm.stdRiskTxtRef = data.stdRiskTxt.stdRiskTxtRef
            this.stdRiskTextForm.stdRiskTxtLn = data.stdRiskTxt.stdRiskTxtLn
            this.stdRiskTextForm.stdRiskDetLn = data.stdRiskTxt.stdRiskDetLn
          }
        } catch (error) {
          console.log(error)
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    async doInit() {
      await this.$store.dispatch('stdRiskItemTextInit')
      this.loading = true
      const apiURI = this.stdRiskItemTextMenu.menu.stdRiskItemTxts
      if (apiURI) {
        try {
          const expand = {
            stdRiskTxtRef: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((stdRiskItemTxt) => {
              const convertList = {
                stdRiskTxtRef: stdRiskItemTxt.stdRiskTxtRef,
                stdItemTxtRef: stdRiskItemTxt.stdItemTxtRef,
                stdItemTxtLn: stdRiskItemTxt.stdItemTxtLn,
                stdItemOptTxtLn: stdRiskItemTxt.stdItemOptTxtLn
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.loading = false
          }
        } catch (error) {
          this.loading = false
          console.log(error)
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.loading = false
        this.errorMessage('Invalid API Url')
      }
    },
    async doReview(item) {
      const apiURI = this.stdRiskItemTextMenu.menu.stdRiskItemTxt
      if (apiURI) {
        try {
          const expand = {
            stdRiskTxtRef: item.item.stdRiskTxtRef,
            stdItemTxtRef: item.item.stdItemTxtRef
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.stdRiskItemTextForm.stdRiskTxtRef = data.stdRiskItemTxt.stdRiskTxtRef
            this.stdRiskItemTextForm.stdItemTxtRef = data.stdRiskItemTxt.stdItemTxtRef
            this.stdRiskItemTextForm.stdItemTxtLn = data.stdRiskItemTxt.stdItemTxtLn
            this.stdRiskItemTextForm.stdItemOptTxtLn = data.stdRiskItemTxt.stdItemOptTxtLn
            // control
            this.newStdRiskItemText = false
            this.stdItemTextDialog = true
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url')
      }
    },
    doCloseItemText() {
      this.newStdRiskText = false
      this.stdItemTextDialog = false
      this.labels.formTitle = 'Review Item Text'
      this.resetItemTextForm()
      this.resetValidator()
      this.resetMessages()
    },
    doNewItemText() {
      this.labels.formTitle = 'New Item Text'
      this.newStdRiskItemText = true
      this.stdItemTextDialog = true
    },
    itemTextSave() {
      this.resetMessages()
      this.$validator.validateAll('stdRiskItemTextForm').then(result => {
        if (result) {
          if (this.newStdRiskItemText) {
            this.doCreateItemText()
          } else {
            this.doUpdateItemText()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    resetItemTextForm() {
      this.stdRiskItemTextForm.stdRiskTxtRef = this.id
      this.stdRiskItemTextForm.stdItemTxtRef = null
      this.stdRiskItemTextForm.stdItemTxtLn = null
      this.stdRiskItemTextForm.stdItemOptTxtLn = null
    },
    async doSaveStdRiskText() {
      this.resetMessages()
      this.$validator.validateAll('stdRiskTextForm').then(result => {
        if (result) {
          if (this.newStdRiskText) {
            this.doCreateStdRiskText()
          } else {
            this.doUpdateStdRiskText()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateItemText() {
      const apiURI = this.stdRiskItemTextMenu.menu.stdRiskItemTxtCreate
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            stdRiskTxtRef: this.id,
            stdItemTxtRef: this.stdRiskItemTextForm.stdItemTxtRef,
            stdItemTxtLn: this.stdRiskItemTextForm.stdItemTxtLn,
            stdItemOptTxtLn: this.stdRiskItemTextForm.stdItemOptTxtLn
          }
          const result = this.$http.post(apiURI, formatForm)
          const { data } = await result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doCloseItemText()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdateItemText() {
      const apiURI = this.stdRiskItemTextMenu.menu.stdRiskItemTxtUpdate
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            stdRiskTxtRef: this.id,
            stdItemTxtRef: this.stdRiskItemTextForm.stdItemTxtRef,
            stdItemTxtLn: this.stdRiskItemTextForm.stdItemTxtLn,
            stdItemOptTxtLn: this.stdRiskItemTextForm.stdItemOptTxtLn
          }
          const result = this.$http.put(apiURI, formatForm)
          const { data } = await result
          if (data) {
            this.notify(data)
            this.doInit()
            this.doCloseItemText()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doCreateStdRiskText() {
      const apiURI = this.stdRiskTextMenu.menu.stdRiskTxtCreate
      if (apiURI) {
        this.submitting = true
        try {
          const formatForm = {
            stdRiskTxtRef: this.stdRiskTextForm.stdRiskTxtRef,
            stdRiskTxtLn: this.stdRiskTextForm.stdRiskTxtLn,
            stdRiskDetLn: this.stdRiskTextForm.stdRiskDetLn
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$router.push({ name: 'stdRiskText' })
          }
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    async doUpdateStdRiskText() {
      const apiURI = this.stdRiskTextMenu.menu.stdRiskTxtUpdate
      if (apiURI) {
        this.submitting = true
        try {
          if (this.stdRiskTextForm.stdRiskDetLn === undefined) {
            this.stdRiskTextForm.stdRiskDetLn = null
          }
          const formatForm = {
            stdRiskTxtRef: this.id,
            stdRiskTxtLn: this.stdRiskTextForm.stdRiskTxtLn,
            stdRiskDetLn: this.stdRiskTextForm.stdRiskDetLn
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedItemText = data
        this.deleteItemText = data.stdRiskTxtRef + ' - ' + data.stdItemTxtRef
      }
    },
    async doRemove() {
      const apiURI = this.stdRiskItemTextMenu.menu.stdRiskItemTxtDelete
      if (apiURI) {
        const expand = this.selectedItemText
        this.$http.post(apiURI, expand).then(result => {
          const data = result.data
          this.notify(data)
          this.doInit()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    }
  },
  created() {
    if (this.id === 'new') {
      this.newStdRiskText = true
      this.$emit('doNewStdRisk', this.newStdRiskText)
    } else {
      Promise.all([this.stdRiskTextFormInit()])
      this.newStdRiskText = false
      this.$emit('doNewStdRisk', this.newStdRiskText)
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>
</style>
